import FormDropdown from "../../../../components/FormDropdown/FormDropdown"
import FormInput from "../../../../components/FormInput/FormInput"
import { MAX_SCOPE_WORKFLOW_SECTIONS, MAX_SECTION_ANGLES } from "../../../../utils/constants"
import { PatchAddSectionFormProps } from "./PatchAddSectionForm.types"
import "./PatchSectionForm.css"

const PatchSectionForm = (props: PatchAddSectionFormProps) => {

  const {
    cornerTypes,
    sectionWidths,
    onChangeSectionWidths,
    sectionHeights,
    onChangeSectionHeights,
    onSelectSection,
    sectionPositions,
    currentSection,
    onAddSection,
    onRemoveCurrentSection,

  } = props

  const removeSection = (e: React.MouseEvent<HTMLDivElement>, index: number) => {
    e.stopPropagation()
    onRemoveCurrentSection()
  }

  return (
    <div className="section-form-container">
      <div className="pipe-section-container">
        <div className="pipe-container">
          <div className="pipe-body">
            {sectionWidths.map((_, key) => (
              <div
                key={key+1}
                className={`pipe-section ${currentSection === key ? "pipe-section-selected": ""}`}
                onClick={() => onSelectSection(key)}
              >
                <div className="pipe-section-delete" onClick={(e) => removeSection(e, key)}>
                  <p>-</p>
                </div>
                <p>Section {key+1}</p>
              </div>
            ))}

            {sectionWidths.length < MAX_SCOPE_WORKFLOW_SECTIONS && (
              <div className="add-pipe-section" onClick={onAddSection}>
                <p>Add Patch Section</p>
              </div>
            )}

          </div>
        </div>
      </div>
      
      <div className="section-info-flex-container">
        <div className="current-section-container">
          <h3>Section information</h3>
          <div className="current-section-info">
            <FormInput
              label="Width"
              input={{
                value: sectionWidths[currentSection]?.value ?? "",
                onChange: (value: string) => onChangeSectionWidths(value, null),
                error: sectionWidths[currentSection]?.error ?? null
              }}
            />

            <FormInput
              label="Scan Distance"
              input={{
                value: sectionHeights[currentSection]?.value ?? "0",
                onChange: (value: string) => onChangeSectionHeights(value, null),
                error: sectionHeights[currentSection]?.error ?? null
              }}
            />

            <FormDropdown
              label="Scan Origin Corner Type"
              className="pipe-id-input"
              dropdown={cornerTypes}
            />
          </div>


        </div>
        
        <div className="angles-container">
          <div className="section-container-header">
            <h3>Section Positions</h3>
          </div>
          <div className="section-angles">
            {sectionPositions[currentSection] !== undefined && (
              <>
                {sectionPositions[currentSection].map((position, key) => (
                  <div key={key} className="section-angle-row">
                    <p>{`${key+1}: ${position}mm`}</p>
                  </div>
                ))}

                {sectionPositions[currentSection].length === 0 && (
                  <div className="no-results-container">
                    <p>No section angles.</p>
                  </div>
                )}
              </>
            )}
            
          </div>
        </div>
      </div>
    </div>
  )
}

export default PatchSectionForm